module.exports = __webpack_public_path__ + "static/media/profilepic.edc33a33.jpg";